import React from 'react';
import { Tag, Tooltip } from 'antd';
import { CloseOutlined } from '@ant-design/icons';

import './editable-tag-group.scss';



const EditableTagGroup = ({
  children,
  closeButtonLabel,
  renderLabel,
  setTags,
  tagClassName = '',
  tags,
  truncate = true,
}) => {

  const handleClose = removedTag => {
    tags = tags.filter(({ value }) => value !== removedTag).map(({ value }) => value);
    setTags(tags);
  };

  return (
    <>
      { tags?.map((tag, index) => {

        const { label, value } = tag;

        const isLongTag = truncate && label.length > 20;
        const content = renderLabel ? renderLabel(tag) :
          isLongTag ? `${ label.slice(0, 20) }...` : label;
        const resolvedCloseButtonLabel = typeof closeButtonLabel === 'function' ?
          closeButtonLabel(tag) : closeButtonLabel;

        const tagElem = (
          <Tag
            className={ `tag-main edit-tag ${ tagClassName }` }
            key={ value }
            closable={ index !== -1 }
            closeIcon={ resolvedCloseButtonLabel ?
              <button
                type="button"
                className="editable-tag-group__close-button"
                aria-label={ resolvedCloseButtonLabel }>
                <CloseOutlined aria-hidden="true" />
              </button> : undefined
            }
            onClose={ () => handleClose(value) }
          >
            <span
              className="tag-text"
            >
              { content }
            </span>
          </Tag>
        );
        return isLongTag ? (
          <Tooltip title={ label } key={ value }>
            { tagElem }
          </Tooltip>
        ) : (
          tagElem
        );
      }) }

      { children }
    </>
  );

}

export default EditableTagGroup;

